import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Crown } from 'lucide-react';
import './PremiumUnlockCard.css';

const defaultHighlights = [
    'Free keeps marketplace, venue discovery, blogs, and news open.',
    'Premium unlocks unlimited scoring and deeper performance insights.',
    'Premium adds member perks and premium-only content.'
];

const PremiumUnlockCard = ({
    title = 'Unlock Premium',
    description = 'Upgrade when you want more depth and fewer limits in your member workflow.',
    highlights = defaultHighlights,
    ctaLabel = 'See Premium Plans',
    compact = false
}) => {
    const navigate = useNavigate();

    return (
        <div className={`premium-unlock-card ${compact ? 'compact' : ''}`}>
            <div className="premium-unlock-icon">
                <Crown size={20} />
            </div>
            <div className="premium-unlock-content">
                <h3>{title}</h3>
                <p>{description}</p>
                <ul>
                    {highlights.map((highlight, index) => (
                        <li key={index}>{highlight}</li>
                    ))}
                </ul>
            </div>
            <button onClick={() => navigate('/dashboard/subscription')} className="premium-unlock-btn">
                {ctaLabel}
                <ArrowRight size={16} />
            </button>
        </div>
    );
};

export default PremiumUnlockCard;
